import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  fetchTrustedHealthCareDetails,
  editTrustedHealthCareDetails,
  updateTrustedHealthCareDetails,
  trashTrustedHealthCareDeatils,
  // fetchinsurancePartners,
  // editInsurancePartners,
  // updateinsurancePartness,
  // trashInsurancePartners,
} from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import { DataGrid } from "@mui/x-data-grid";
import ReactQuill from "react-quill";
import CKEditorField from "../../components/CKEditorField";

const AddInternationalPatients = () => {
  const [data, setData] = useState([]);
  // const [specialties, setSpecialties] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  // const [editSpecialtyRow, setEditSpecialtyRow] = useState(null);

  //fetch speicalities

  useEffect(() => {
    const loadtrustedData = async () => {
      try {
        const [trustedRes] = await Promise.all([
          fetchTrustedHealthCareDetails(),
        ]);
        // console.log(response, "here is fetch data");
        if (trustedRes?.data) setData([trustedRes.data]);
        else setError("Failed to fetch trusted Data");
      } catch (error) {
        setError("An Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    loadtrustedData();
  }, []);

  const handleEdit = async (id) => {
    try {
      const response = await editTrustedHealthCareDetails(id);
      if (response && response.data) {
        const data = response.data;

        setEditRow({
          id: data.id,
          heading: data.heading,
          content: data.content,
          img_path: data.img_path,
        });
      } else {
        toast.error("Failed to Load TrustedDetails");
      }
    } catch (error) {
      toast.error("Error loading edit Data: ", error);
    }
  };

  const handleSaveEdit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("heading", editRow.heading);
    formData.append("content", editRow.content);
    if (editRow.img_path instanceof File) {
      formData.append("img_path", editRow.img_path);
    }

    try {
      const response = await updateTrustedHealthCareDetails(
        editRow.id,
        formData
      );
      if (response && response.status === "true") {
        toast.success("HealthCare Updated successfully");
        setData((prev) =>
          prev.map((data) =>
            data.id === editRow.id
              ? {
                  ...data,
                  heading: editRow.heading,
                  content: editRow.content,
                  img_path: editRow.img_path,
                }
              : data
          )
        );
        setEditRow(null);
      } else {
        toast.error("Failed to update data");
      }
    } catch (error) {
      toast.error("Error Saving Edit :", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await trashTrustedHealthCareDeatils(id);
      if (response && response.status === "true") {
        toast.success("TrustedHealthCare Details deleted successfully");
        setData((prev) => prev.filter((data) => data.id !== id));
        setDeleteItem(null);
      } else {
        toast.error("Failed to delete Details");
      }
    } catch (error) {
      toast.error("Failed to delete Details.");
    } finally {
      setActionLoading(false);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "heading", headerName: "Heading", width: 250 },
    {
      field: "content",
      headerName: "Content",
      width: 350,
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html:
              params.value.length > 100
                ? params.value.substring(0, 100) + "..."
                : params.value,
          }}
        />
      ),
    },
    {
      field: "img_path",
      headerName: "Image",
      width: 120,
      renderCell: (params) => {
        const imageUrl = params.row.img_path
          ? `${baseImage_path}/${params.row.img_path}`
          : "/default-banner.jpg"; // Use a default image if `img_path` is missing

        return (
          <img
            src={imageUrl}
            alt="Banner"
            style={{ width: "100%", height: "50px", objectFit: "cover" }}
          />
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleEdit(params.row.id)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => setDeleteItem(params.row.id)}
            style={{ marginLeft: "8px" }}
          >
            Trash
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box m={3}>
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        International Patients - Trusted Healthcare
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <>
          <DataGrid rows={data} columns={columns} autoHeight />
        </>
      )}

      {/* Trusted HealthCare */}
      {editRow && (
        <Dialog open onClose={() => setEditRow(null)} maxWidth="md" fullWidth>
          <DialogTitle>Edit Entry</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Heading"
              margin="normal"
              value={editRow.heading}
              onChange={(e) =>
                setEditRow({ ...editRow, heading: e.target.value })
              }
            />

            <Typography variant="subtitle1" gutterBottom>
              Content
            </Typography>
            {/* <ReactQuill
              theme="snow"
              value={editRow.content}
              onChange={(value) => setEditRow({ ...editRow, content: value })}
              style={{ height: "200px", marginBottom: "30px" }}
            /> */}
            <CKEditorField
            value={editRow.content}
            onChange={(data) => setEditRow((prev) => ({ ...prev, content: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=InternationalPatient`}
          />
            <Typography variant="subtitle1" gutterBottom mt={12}>
              Upload Image
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setEditRow({ ...editRow, img_path: e.target.files[0] })
              }
            />

            <Box mt={2}>
              {editRow.img_path && (
                <Box mt={2}>
                  <Typography variant="subtitle2">Preview:</Typography>
                  <img
                    src={
                      typeof editRow.img_path === "string"
                        ? `${baseImage_path}/${editRow.img_path}`
                        : URL.createObjectURL(editRow.img_path)
                    }
                    alt="Preview"
                    style={{ width: 100, height: 100, objectFit: "cover" }}
                  />
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setEditRow(null)}
              variant="outlined"
              style={{ backgroundColor: "gray", color: "white" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSaveEdit}
              variant="contained"
              color="primary"
              disabled={actionLoading}
            >
              {actionLoading ? <CircularProgress size={24} /> : "Save"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {deleteItem && (
        <Dialog open onClose={() => setDeleteItem(null)}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this Details?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDeleteItem(null)}
              variant="outlined"
              style={{ fontWeight: "bold", backgroundColor: "grey" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleDelete(deleteItem)}
              disabled={actionLoading}
            >
              {actionLoading ? <CircularProgress size={24} /> : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Specailites */}
    </Box>
  );
};

export default AddInternationalPatients;
